let dots = document.querySelectorAll('.nav_dot');
let slides = document.querySelectorAll('.slider-with-text-slide');
let innerImg = document.querySelectorAll('.nav_dot_img-inner');
let slideIndex = 0;
let slideItems = document.querySelectorAll('.slider-list-item');
let rightArrow = document.getElementsByClassName('slide-item-arrow-right')[0];
let leftArrow = document.getElementsByClassName('slide-item-arrow-left')[0];
let sliderDots = document.getElementsByClassName('slider-dots')[0];

// MOVE SLIDE

const showSlide = function(n){
    if (n > slides.length) {
      slideIndex = 0
    };
    if (n < slideIndex){
      slideIndex = slides.length - 1
    }
    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    for (i = 0; i < innerImg.length; i++){
        innerImg[i].classList.remove('focusin','dot-clicked');
    }
    for (i = 0; i < dots.length; i++) {
      slideItems[i].classList.add('item-none');
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex].style.display = "block";
    dots[slideIndex].className += " active";
    innerImg[slideIndex].classList.add('focusin','dot-clicked');
    slideItems[slideIndex].classList.replace('item-none','item-block');

}

// RIGHT ARROW

const showMobileSlidetoRight = function(){
  slideIndex++;
  
  showSlide(slideIndex);
  // if (slideIndex > 3){
  //   slideIndex = 0;
  // }   
  // for (let i = 0; i < slides.length; i++) {
  //   slides[i].style.display = "none";
  // }
  // for (i = 0; i < dots.length; i++) {
  //   slideItems[i].style.display = "none";
  //   dots[i].className = dots[i].className.replace(" active", "");
  // }

  // slides[slideIndex].style.display = "block";
  // dots[slideIndex].className += " active";
  // slideItems[slideIndex].style.display = "block";

  // if (slideIndex === slides.length-1) {
  //   rightArrow.style.display = "none";
  // } 

  // if(slideIndex > 0){
  //   leftArrow.style.display = "block";
  // }
  
}

rightArrow.addEventListener('click',showMobileSlidetoRight)

// LEFT ARROW

const showMobileSlidetoLeft = function(){
  slideIndex--;
  console.log(slideIndex)
  showSlide(slideIndex);
  // if (slideIndex < 0){
  //   slideIndex = slides.length - 1
  // }
  
//   for (let i = 0; i < slides.length; i++) {
//     slides[i].style.display = "none";
//   }

//   for (let i = 0; i < dots.length; i ++) {
//     slideItems[i].style.display = "none";
//     dots[i].className = dots[i].className.replace(" active", "");
// }
  
//   slides[slideIndex].style.display = "block";
//   dots[slideIndex].className += " active";
//   slideItems[slideIndex].style.display = "block";

}

leftArrow.addEventListener('click',showMobileSlidetoLeft)

// SLIDE FUNCTION

let xStartPosition;
let xEndPosition;
function captureX(e){
  xStartPosition = e.touches[0].clientX;
}

function slideValidator(e){
  xEndPosition = e.changedTouches[0].clientX;
  if(slideIndex < slides.length - 1){
    if(xEndPosition < xStartPosition){
      showMobileSlidetoRight();
    }
  } else {
    e.preventDefault();
  }
  if (slideIndex != 0) {
    if (xEndPosition > xStartPosition) {
      showMobileSlidetoLeft();
    }
  } else {
    e.preventDefault();
  }
}
sliderDots.addEventListener('touchstart',captureX);
sliderDots.addEventListener('touchend',slideValidator);

// CONNECT DOTS WITH SLIDER

dots.forEach(dotCounter);

function dotCounter(item,index){
    item.addEventListener('click', () => {currentSlide(index)});
}

function currentSlide(n) {
    showSlide(slideIndex = n);
  } 


// SCALE THE DOTS IMAGE ON MOUSEOVER

 innerImg.forEach(function(inner){
  inner.addEventListener('focusin',function(e){
    inner.classList.add('focusin');
    inner.classList.add('dot-clicked');
  });

  inner.addEventListener('focusout',function(e){
    inner.classList.remove('focusin');
    inner.classList.remove('dot-clicked');
  })

  inner.addEventListener('mouseover',function(e){
    if(inner.classList.contains('dot-clicked')){
      return;
    } else {
      inner.classList.add('focusin');
    }
})
  inner.addEventListener('mouseout',function(e){
    if(inner.classList.contains('dot-clicked')){
      return;
    } else {
      inner.classList.remove('focusin');
    }
    
})
})

// EJECT THE FUNCTION WHEN THE PAGE IS LOADED

window.addEventListener('load', showSlide(0));